export default __webpack_public_path__ + "static/media/hht1_storybook_09.f8aa5ac2.png";